import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a882188"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vehicle-checkbox"
}
const _hoisted_2 = { class: "checkbox" }
const _hoisted_3 = ["disabled", "checked"]
const _hoisted_4 = {
  key: 1,
  class: "dashboard__table-td c-size-190"
}
const _hoisted_5 = { class: "on-order-button" }
const _hoisted_6 = {
  key: 2,
  class: "dashboard__table-td c+size-190"
}
const _hoisted_7 = {
  disabled: "",
  class: "to-pay-status"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "status-text" }
const _hoisted_10 = { class: "status-text" }
const _hoisted_11 = {
  key: 3,
  class: "dashboard__table-td c+size-190"
}
const _hoisted_12 = { class: "transport-status-container" }
const _hoisted_13 = { class: "transport-status-button" }
const _hoisted_14 = { style: {"margin-top":"1px"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "status-text" }
const _hoisted_17 = {
  key: 4,
  class: "dashboard__table-td c+size-190"
}
const _hoisted_18 = { class: "dashboard__table-column vehicle-column" }
const _hoisted_19 = { class: "processing-documents-button" }
const _hoisted_20 = {
  key: 0,
  class: "processing-documents-details"
}
const _hoisted_21 = {
  key: 1,
  class: "processing-documents-details"
}
const _hoisted_22 = {
  key: 2,
  class: "processing-documents-details"
}
const _hoisted_23 = {
  key: 5,
  class: "dashboard__table-td c+size-190"
}
const _hoisted_24 = { class: "dashboard__table-column vehicle-column" }
const _hoisted_25 = {
  disabled: "",
  class: "completed-button"
}
const _hoisted_26 = { class: "status-text delivery-date-span" }
const _hoisted_27 = { class: "status-text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Payment Received:", -1))
const _hoisted_29 = { class: "status-text" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CMR:", -1))
const _hoisted_31 = { class: "dashboard__table-td c+size-161" }
const _hoisted_32 = { class: "dashboard__popup-item dashboard__carInfo-item c-orders-item-line" }
const _hoisted_33 = { style: {"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"} }
const _hoisted_34 = { style: {"width":"136px"} }
const _hoisted_35 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"600","line-height":"19px","word-wrap":"break-word"} }
const _hoisted_36 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"400","line-height":"19px","word-wrap":"break-word"} }
const _hoisted_37 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"600","line-height":"19px","word-wrap":"break-word"} }
const _hoisted_38 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"600","word-wrap":"break-word"} }
const _hoisted_39 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"400","word-wrap":"break-word"} }
const _hoisted_40 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"600","word-wrap":"break-word"} }
const _hoisted_41 = { style: {"color":"#283747","font-size":"12px","font-family":"var(--font-family)","font-weight":"400","word-wrap":"break-word"} }
const _hoisted_42 = { class: "dashboard__table-td dashboard__table-td c+size-345" }
const _hoisted_43 = {
  class: "dashboard__popup-item dashboard__carInfo-item c-orders-item-line",
  style: {"border":"none"}
}
const _hoisted_44 = { class: "car-preview-container" }
const _hoisted_45 = ["src"]
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "dashboard__carInfo-info" }
const _hoisted_48 = { class: "car-model-info" }
const _hoisted_49 = { class: "car-specs" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = {
  class: "additional-details",
  style: {"display":"table-column"}
}
const _hoisted_53 = { class: "label" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "label" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { class: "dashboard__table-td dashboard__table-td c+size-220 order-info-label" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "label" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "label" }
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { class: "label" }
const _hoisted_64 = { class: "label" }
const _hoisted_65 = { key: 3 }
const _hoisted_66 = { class: "label" }
const _hoisted_67 = { key: 4 }
const _hoisted_68 = { class: "label" }
const _hoisted_69 = { key: 5 }
const _hoisted_70 = { class: "label" }
const _hoisted_71 = { class: "dashboard__table-td dashboard__table-td c+size-220" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-orders-item-line-last" }, null, -1))
const _hoisted_73 = { class: "dashboard__popup-column dashboard__popup-price c-price-details" }
const _hoisted_74 = { class: "dashboard__popup-priceBlock" }
const _hoisted_75 = { class: "text-right" }
const _hoisted_76 = { class: "dashboard__popup-priceBlock" }
const _hoisted_77 = { class: "text-right" }
const _hoisted_78 = { class: "dashboard__popup-priceBlock" }
const _hoisted_79 = {
  key: 0,
  class: "text-right"
}
const _hoisted_80 = {
  key: 1,
  class: "text-right"
}
const _hoisted_81 = { class: "dashboard__popup-priceBlock" }
const _hoisted_82 = {
  key: 0,
  class: "text-right"
}
const _hoisted_83 = {
  key: 1,
  class: "text-right"
}
const _hoisted_84 = { class: "dashboard__popup-priceBlock" }
const _hoisted_85 = { class: "text-right" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"width":"100%","background":"#283747"} }, null, -1))
const _hoisted_88 = { class: "dashboard__popup-priceBlock" }
const _hoisted_89 = { class: "text-right" }
const _hoisted_90 = { class: "dashboard__table-td dashboard__table-td c+size-142" }
const _hoisted_91 = { class: "dashboard__table-column vehicle-column" }
const _hoisted_92 = {
  key: 2,
  style: {"width":"100%","user-select":"none"}
}
const _hoisted_93 = ["disabled"]
const _hoisted_94 = {
  key: 0,
  class: "p-button-loading-icon pi pi-spinner pi-spin"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  height: "18",
  src: "/img/list.svg",
  alt: "#"
}, null, -1))
const _hoisted_96 = { style: {"margin-left":"12px"} }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  height: "18",
  src: "/img/payment.svg",
  alt: "#"
}, null, -1))
const _hoisted_98 = { style: {"margin-left":"12px"} }
const _hoisted_99 = { class: "c-pickup-hours-label" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon dashboard__table-icon",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#icon-credit" })
], -1))
const _hoisted_101 = { class: "table-badge__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_confirm_date_popup = _resolveComponent("confirm-date-popup")!
  const _component_p_calendar = _resolveComponent("p-calendar")!
  const _component_DeclinePopup = _resolveComponent("DeclinePopup")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_manual_transfer_popup = _resolveComponent("manual-transfer-popup")!
  const _component_upload_cmr_popup = _resolveComponent("upload-cmr-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`vehicle-dashboard
        ${_ctx.isSelected ? 'vehicle-selected' : ''}`),
      style: _normalizeStyle(_ctx.isSelected ? ['background: rgba(26, 160, 225, 0.10)'] : ['']),
      role: "row"
    }, [
      (['3', '4', '5'].includes(_ctx.orderStatus))
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", null, [
                _createElementVNode("input", {
                  disabled: !_ctx.isSelectionAllowed,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectCar && _ctx.selectCar(...args))),
                  type: "checkbox",
                  checked: _ctx.isSelected
                }, null, 40, _hoisted_3),
                _createElementVNode("i", {
                  style: _normalizeStyle(
                            !_ctx.isSelectionAllowed
                                ? 'background: transparent; cursor: not-allowed'
                                : _ctx.isSelected
                                ? ''
                                : 'background: white'
                        )
                }, null, 4)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.orderStatus === 'on_order' || _ctx.orderStatus === '2')
        ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_5, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.onOrder" })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.orderStatus === 'to_pay' || _ctx.orderStatus === '3')
        ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.orderVehicle.status.name), 1),
              (_ctx.isAwaitingPayment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_9, [
                        _createVNode(_component_i18n_t, { keypath: "myOrders.prePaid" }),
                        _createTextVNode(" : ")
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.payments?.amount_paid_confirmed,
                          currency: "EUR"
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.orderStatus === 'to_transport' || _ctx.orderStatus === '4')
        ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.orderVehicle.status.name), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.orderStatus.id === 'transport')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.orderStatus.name) + ": 7", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.orderStatus === 'processing_documents' || _ctx.orderStatus === '5')
        ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.orderVehicle.status.name), 1),
              (_ctx.orderVehicle.status.id === 15)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.verifying" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.orderVehicle.status.id === 13)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.afterReceived" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.orderVehicle.status.id === 16)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.shippingDocuments" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.orderStatus === 'completed' || _ctx.orderStatus === '6')
        ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", _hoisted_25, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.completed.title" })
              ]),
              _createElementVNode("span", _hoisted_26, [
                _createElementVNode("b", null, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.completed.description" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.order.date)), 1)
              ]),
              _createElementVNode("span", _hoisted_27, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.order.date)), 1)
              ]),
              _createElementVNode("span", _hoisted_29, [
                _hoisted_30,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.order.date)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("td", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.carAvailability" }),
                _createTextVNode(" : ")
              ]),
              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.orderVehicle?.availability?.name?.includes("Stock")
                                    ? _ctx.i18n.t("myOrders.Stock")
                                    : _ctx.i18n.t("myOrders.notAvailable")), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_i18n_t, { keypath: "myOrders.documentAvailability" })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_38, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.COC" }),
                _createTextVNode(" : ")
              ]),
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.isCocAvailable
                                    ? _ctx.i18n.t("myOrders.available")
                                    : _ctx.i18n.t("myOrders.NA")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_40, [
                _createVNode(_component_i18n_t, { keypath: "myOrders.REG" }),
                _createTextVNode(" : ")
              ]),
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.isRegAvailable
                                    ? _ctx.i18n.t("myOrders.available")
                                    : _ctx.i18n.t("myOrders.NA")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("td", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            (_ctx.orderVehicle.thumbnail_image?.href_small)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.orderVehicle.thumbnail_image?.href_small
                }, null, 8, _hoisted_45))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["no-image-block", _ctx.isAstara ? 'astara': ''])
                }, [
                  _createElementVNode("img", {
                    width: "80",
                    height: "60",
                    src: `/img/${_ctx.brandLabel}/no-image.svg`
                  }, null, 8, _hoisted_46)
                ], 2))
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.orderVehicle.vehicle.brand.name +
                            " " +
                            _ctx.orderVehicle.vehicle.model +
                            " " +
                            _ctx.orderVehicle.vehicle.finish +
                            " " +
                            _ctx.orderVehicle.vehicle.powertrain.gearbox.name +
                            " " +
                            _ctx.orderVehicle.vehicle.powertrain.fueltype.name), 1),
            _createElementVNode("div", _hoisted_49, [
              _createTextVNode(_toDisplayString(_ctx.orderVehicle.vehicle.powertrain.motorisation) + " ", 1),
              _hoisted_50,
              _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle.color_factory) + " ", 1),
              _hoisted_51,
              _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle.powertrain.power_hp +
                            " hp (" +
                            _ctx.orderVehicle.vehicle.powertrain.power_kw +
                            " kw)"), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("span", _hoisted_53, [
                _createVNode(_component_i18n_t, { keypath: "carDetails.ID" }),
                _createTextVNode(" : ")
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.orderVehicle.vehicle.id), 1),
              (_ctx.orderVehicle?.vehicle_vin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("span", _hoisted_55, [
                      _createVNode(_component_i18n_t, { keypath: "carDetails.VIN" }),
                      _createTextVNode(" : ")
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.orderVehicle.vehicle_vin), 1),
                    _hoisted_56
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("td", _hoisted_57, [
        _createElementVNode("div", null, [
          (_ctx.orderVehicle.vehicle?.condition.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_58, [
                _createElementVNode("span", _hoisted_59, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.condition" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle?.condition.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderVehicle.vehicle?.mileage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_60, [
                _createElementVNode("span", _hoisted_61, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.mileage" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle?.mileage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderVehicle.vehicle?.firstregistration_date)
            ? (_openBlock(), _createElementBlock("p", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.firstregistration_date" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.orderVehicle.vehicle.firstregistration_date)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _createElementVNode("span", _hoisted_64, [
              _createVNode(_component_i18n_t, { keypath: "carDetails.color" }),
              _createTextVNode(" : ")
            ]),
            _createTextVNode(" " + _toDisplayString(`${_ctx.orderVehicle.vehicle.color.name} (Ext: ${
                            _ctx.orderVehicle.vehicle.color_factory
                        }${
                            _ctx.orderVehicle.vehicle.color_interior_factory
                                ? " / Int: " + _ctx.orderVehicle.vehicle.color_interior_factory
                                : ""
                        })`), 1)
          ]),
          (_ctx.orderVehicle.vehicle?.powertrain?.gearbox?.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_65, [
                _createElementVNode("span", _hoisted_66, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.gearbox" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle?.powertrain?.gearbox?.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderVehicle.vehicle?.powertrain?.drivetrain?.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_67, [
                _createElementVNode("span", _hoisted_68, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.drivetrain" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle?.powertrain?.drivetrain?.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderVehicle.vehicle?.powertrain?.fueltype?.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_69, [
                _createElementVNode("span", _hoisted_70, [
                  _createVNode(_component_i18n_t, { keypath: "carDetails.fueltype" }),
                  _createTextVNode(" : ")
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.orderVehicle.vehicle?.powertrain?.fueltype?.name), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("td", _hoisted_71, [
        _hoisted_72,
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("strong", null, [
              _createVNode(_component_i18n_t, { keypath: "cart.vehicle" })
            ]),
            _createElementVNode("strong", _hoisted_75, [
              _createVNode(_component_app_format_currency, {
                value: _ctx.orderVehicle?.price_vehicle_ex_vat ?? 0,
                currency: _ctx.order?.currency
              }, null, 8, ["value", "currency"])
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("strong", null, [
              _createVNode(_component_i18n_t, { keypath: "cart.feeTransport" })
            ]),
            _createElementVNode("strong", _hoisted_77, [
              _createVNode(_component_app_format_currency, {
                value: _ctx.orderVehicle?.price_transport_ex_vat ?? 0,
                currency: _ctx.order?.currency
              }, null, 8, ["value", "currency"])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("strong", null, [
              _createVNode(_component_i18n_t, { keypath: "cart.feeAdministration" })
            ]),
            (_ctx.orderVehicle?.price_admin_handling_ex_vat != undefined)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_79, [
                  _createVNode(_component_app_format_currency, {
                    value: _ctx.orderVehicle?.price_admin_handling_ex_vat ?? 0,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ]))
              : (_openBlock(), _createElementBlock("strong", _hoisted_80, "TBD"))
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("strong", null, [
              _createVNode(_component_i18n_t, { keypath: "cart.vat" })
            ]),
            (_ctx.orderVehicle?.vat_amount != undefined)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_82, [
                  _createVNode(_component_app_format_currency, {
                    value: _ctx.orderVehicle?.vat_amount ?? 0,
                    currency: "EUR"
                  }, null, 8, ["value"])
                ]))
              : (_openBlock(), _createElementBlock("strong", _hoisted_83, "TBD"))
          ]),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("strong", null, [
              _createVNode(_component_i18n_t, { keypath: "cart.dealReduction" })
            ]),
            _createElementVNode("strong", _hoisted_85, [
              _createVNode(_component_app_format_currency, {
                value: (_ctx.orderVehicle?.deal_reduction > 0 ? -_ctx.orderVehicle?.deal_reduction : 0),
                currency: "EUR"
              }, null, 8, ["value"])
            ])
          ]),
          _hoisted_86,
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("strong", null, [
              _createVNode(_component_i18n_t, { keypath: "cart.subtotal" })
            ]),
            _createElementVNode("strong", _hoisted_89, [
              (!_ctx.isOrderWithTBD)
                ? (_openBlock(), _createBlock(_component_app_format_currency, {
                    key: 0,
                    value: Number(_ctx.orderVehicle.total_price_including_vat),
                    currency: _ctx.order?.currency
                  }, null, 8, ["value", "currency"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("TBD")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("td", _hoisted_90, [
        _createElementVNode("div", _hoisted_91, [
          true
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (
                            ((_ctx.orderStatus === String('to_pay') || _ctx.orderStatus === '3') &&
                                _ctx.showPayment) ||
                            _ctx.isProcessingPayment
                        )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "dashboard__table-btn width__full btn__light_blue",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = () => (_ctx.showPayPopup = true))
                    }, [
                      _createVNode(_component_i18n_t, { keypath: "myOrders.pay" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showConfirmPopup)
                  ? (_openBlock(), _createBlock(_component_confirm_date_popup, {
                      key: 1,
                      _vehiclesId: _ctx.currentVehicleIdAsList,
                      "onUpdate:_vehiclesId": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentVehicleIdAsList) = $event)),
                      _order: _ctx.order,
                      "onUpdate:_order": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.order) = $event)),
                      _formattedDate: _ctx.formattedSelectedDate,
                      "onUpdate:_formattedDate": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formattedSelectedDate) = $event)),
                      onCloseConfirmPopup: _ctx.closeConfirmPopup
                    }, null, 8, ["_vehiclesId", "_order", "_formattedDate", "onCloseConfirmPopup"]))
                  : _createCommentVNode("", true),
                (
                            (_ctx.orderStatus === 'to_transport' || _ctx.orderStatus === '4') &&
                            _ctx.isCheckboxToTransport
                        )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      (_ctx.showDatePicker)
                        ? (_openBlock(), _createBlock(_component_p_calendar, {
                            key: 0,
                            style: {"position":"absolute","opacity":"0","height":"1.875rem"},
                            id: "range",
                            "min-date": new Date(Date.now() + 48 * 60 * 60 * 1000),
                            "max-date": new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
                            "input-style": 'cursor: pointer',
                            dateFormat: "dd/mm/yy",
                            selectionMode: "range",
                            manualInput: false,
                            "onUpdate:modelValue": _ctx.handleDateSelected
                          }, null, 8, ["min-date", "max-date", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "dashboard__table-btn width__full btn__blue",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getDatePicker && _ctx.getDatePicker(...args)))
                      }, [
                        _createVNode(_component_i18n_t, { keypath: "myOrders.pickupDate" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
                            (_ctx.orderStatus === 'processing_documents' ||
                                _ctx.orderStatus === '5') &&
                            (_ctx.orderVehicle.status.id === 13 ||
                                _ctx.orderVehicle.status.id === 14)
                        )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "dashboard__table-btn width__full btn__yellow",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = () => (_ctx.showUploadCrmPopup = true))
                    }, [
                      _createVNode(_component_i18n_t, { keypath: "myOrders.uploadCMR" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isPopupOpen)
                  ? (_openBlock(), _createBlock(_component_DeclinePopup, {
                      key: 4,
                      onClick: _ctx.closePopup
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === 'on_order' || _ctx.orderStatus === '2')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
            : (
                        _ctx.isOrderInStatus(_ctx.orderStatusEnum.processing_documents) &&
                        (_ctx.isOrderInSubStatus(_ctx.orderSubStatusEnum.waiting_cmr) ||
                            _ctx.isOrderInSubStatus(_ctx.orderSubStatusEnum.cmr_overdue))
                    )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "dashboard__table-btn",
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = () => (_ctx.showUploadCmr = true))
                }, [
                  _createVNode(_component_i18n_t, { keypath: "myOrders.uploadCMR" })
                ]))
              : _createCommentVNode("", true),
          (!((_ctx.orderStatus === 'to_transport' || _ctx.orderStatus === '4') &&
                            _ctx.isCheckboxToTransport))
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                class: "dashboard__table-link",
                onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadZipByImageId && _ctx.downloadZipByImageId(...args)), ["prevent"])),
                disabled: _ctx.downloadingImages,
                style: {"width":"100%","display":"flex","justify-content":"center","align-items":"center"}
              }, [
                (_ctx.downloadingImages)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_94))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_95,
                      _createElementVNode("span", _hoisted_96, [
                        _createVNode(_component_i18n_t, { keypath: "myOrders.downloadImages" })
                      ])
                    ], 64))
              ], 8, _hoisted_93))
            : _createCommentVNode("", true),
          (_ctx.orderStatus === 'to_pay' || _ctx.orderStatus === '3')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                class: "dashboard__table-link",
                to: "",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openPaymentsTransactionsPopup(_ctx.order.id)))
              }, {
                default: _withCtx(() => [
                  _hoisted_97,
                  _createElementVNode("span", _hoisted_98, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.viewPayment" })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
                        _ctx.orderStatus === 'to_transport' || _ctx.orderStatus === '4'
                        // isOrderInStatus(orderStatusEnum.to_transport) &&
                        // isOrderInSubStatus(orderSubStatusEnum.ready_for_pickup)
                    )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createElementVNode("span", _hoisted_99, [
                  _createElementVNode("b", null, [
                    _createVNode(_component_i18n_t, { keypath: "myOrders.pickupHours" })
                  ]),
                  _createTextVNode(" 08:00 - 16:00 ")
                ]),
                (_ctx.showDatePicker)
                  ? (_openBlock(), _createBlock(_component_p_calendar, {
                      key: 0,
                      style: {"position":"absolute","opacity":"0","height":"1.875rem"},
                      id: "range",
                      "min-date": new Date(Date.now() + 48 * 60 * 60 * 1000),
                      "max-date": new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
                      "input-style": 'cursor: pointer',
                      dateFormat: "dd/mm/yy",
                      selectionMode: "range",
                      manualInput: false,
                      "onUpdate:modelValue": _ctx.handleDateSelected
                    }, null, 8, ["min-date", "max-date", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (!_ctx.isCheckboxToTransport)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "dashboard__table-btn width__full btn__blue pickup-date-button",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getDatePicker && _ctx.getDatePicker(...args)))
                    }, [
                      _createVNode(_component_i18n_t, { keypath: "myOrders.pickupDate" })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["dashboard__table-badge table-badge", 
                    _ctx.order.type.id === 1 ? 'table-badge--online' : 'table-badge--offline'
                ])
        }, [
          _hoisted_100,
          _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.order.type.id === 1 ? "online" : "key account"), 1)
        ], 2)
      ])
    ], 6),
    (_ctx.showPayPopup)
      ? (_openBlock(), _createBlock(_component_manual_transfer_popup, {
          key: 0,
          onClose: _cache[11] || (_cache[11] = () => (_ctx.showPayPopup = false)),
          _orderId: _ctx.order.id,
          "onUpdate:_orderId": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.order.id) = $event)),
          _vehiclesId: _ctx.currentVehicleIdAsList,
          "onUpdate:_vehiclesId": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentVehicleIdAsList) = $event)),
          _isProcessingPayment: _ctx.isProcessingPayment,
          "onUpdate:_isProcessingPayment": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isProcessingPayment) = $event))
        }, null, 8, ["_orderId", "_vehiclesId", "_isProcessingPayment"]))
      : _createCommentVNode("", true),
    (_ctx.showUploadCrmPopup)
      ? (_openBlock(), _createBlock(_component_upload_cmr_popup, {
          key: 1,
          onClosePopup: _cache[15] || (_cache[15] = () => (_ctx.showUploadCrmPopup = false)),
          _orderId: _ctx.order.id,
          "onUpdate:_orderId": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.order.id) = $event)),
          _vehiclesId: _ctx.currentVehicleIdAsList,
          "onUpdate:_vehiclesId": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentVehicleIdAsList) = $event))
        }, null, 8, ["_orderId", "_vehiclesId"]))
      : _createCommentVNode("", true)
  ], 64))
}